import { isServer } from "@utils/helpers";
import { useEffect, useRef, useState } from "react";

type Query = string | { min: number; max: number };

export const useMediaQuery = (query: Query) => {
  const mediaQuery = useRef(
    !isServer()
      ? window.matchMedia(
          typeof query === "string"
            ? `(${query})`
            : `(min-width:${query.min}px) and (max-width:${query.max}px)`
        )
      : ({ matches: false } as MediaQueryList)
  ).current;
  const [match, setMatch] = useState(mediaQuery.matches);

  useEffect(() => {
    const listener = (e: MediaQueryListEvent) => {
      setMatch(e.matches);
    };
    if (mediaQuery) mediaQuery.addEventListener("change", listener);
    return () => mediaQuery.removeEventListener("change", listener);
  }, [mediaQuery]);

  return match;
};
